import React from "react";
import { useNavigate } from "react-router-dom";
import { Edit2, DocumentText } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import {
  SettingsCard,
  SettingsMenuItem,
  SettingsSection,
  SettingsSectionTitle,
} from "../../shared/components/SettingsMenuItem";

import { Body, Lead } from "./styles";

const SuggestionsHub: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MobileLayout
      headerTitle="Sugestões"
      headerType="private"
      headerDescription="Ajude a melhorar o sinalário"
    >
      <Body>
        <Lead>
          Envie ideias de novos sinais ou acompanhe as sugestões que você já
          enviou.
        </Lead>

        <SettingsSection>
          <SettingsSectionTitle>Opções</SettingsSectionTitle>
          <SettingsCard>
            <SettingsMenuItem
              title="Enviar sugestão"
              description="Compartilhe um sinal ou melhoria"
              icon={<Edit2 size={22} variant="Bold" />}
              onClick={() => navigate("/enviar-sugestao")}
            />
            <SettingsMenuItem
              title="Minhas sugestões"
              description="Veja o que você já enviou"
              icon={<DocumentText size={22} variant="Bold" />}
              onClick={() => navigate("/sugestoes/minhas")}
            />
          </SettingsCard>
        </SettingsSection>
      </Body>
    </MobileLayout>
  );
};

export default SuggestionsHub;
